export const LOAD_TIMELINES = 'Sentiment / LOAD_TIMELINES';
